$(document).ready(function(){
  $(document).on('click', '#products_list .buttons .btn', function(event) {
    var new_tag = $(this).text().toLowerCase();
    $('#products_list .buttons .btn').removeClass('selected');
    $(this).addClass('selected');
    if( new_tag==="all products" ){
      $('#products_list .carousel-cell').show();
    }
    else{
      $('#products_list .carousel-cell').each(function(e){
        var tags = $(this).attr("tags");
        if( tags.includes(new_tag) ) $(this).show();
        else $(this).hide();
      });
    }
  });
});